var allBoxers = ["Hispanics", "African Americans"];

var margin = {top: 15, right: 15, bottom: 0, left: 126};

var widther = d3.select(".gia-chart-wrapper").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 75 - margin.top - margin.bottom;

var barHeight = 25;  

//Creates the xScale 
var xScale = d3.scale.linear()
	.range([0,width]);

//Creates the yScale
var y0 = d3.scale.ordinal()
	.rangeBands([height, 0], 0)
	.domain(["Hispanics", "African Americans"]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
  	.scale(y0)
  	.orient("left");

//Defines the x axis styles
var xAxis = d3.svg.axis()
  	.scale(xScale)
  	.orient("top")
  	.ticks(5)
  	.tickSize(-height); 

d3.tsv("data/boxing.tsv", ready);

function ready(err, data) {
	if (err) throw "error loading data";
	console.log(data);

	//FORMAT data
	data.forEach(function(d) {
		d.count = +d.count;
	});

	var maxCount = d3.max(data, function(d) { return d.count; });

	xScale.domain([0, 100]);
	
	var allCategories = d3.set(data.map(function(d) { return d.category; })).values();


	allCategories.forEach(function(d) {
		makeChart(d);
	});

	function makeChart(category) {
		var CategoryName = category;

		var CategoryData = data.filter(function(d) {
			return d.category === CategoryName;
		});

		console.log(CategoryData);

		var chartContainer = d3.select(".gia-chart").append("div")
			.attr("class", "g-chart-container");

		var chartCategory = chartContainer.append("h5")
			.attr("class", "g-category");

		var chart = chartContainer.append("div")
			.attr("class", "g-chart g-chart-"+category.toLowerCase().replace(' ', '-'));

		chartCategory.text(CategoryName);

		//Appends the svg to the chart-container div
		var svg = chart.append("svg")
			.attr("width", width + margin.left + margin.right)
		  	.attr("height", height + margin.top + margin.bottom)
		  	.append("g")
		  	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		//Appends the y axis
		var yAxisGroup = svg.append("g")
		    .attr("class", "y axis")
		    .call(yAxis);

		//Binds the data to the bars      
		var categoryGroup = svg.selectAll(".g-category-group")
		    .data(CategoryData)
		    .enter()
		    .append("g")
		    .attr("class", "g-category-group")
		    .attr("transform", function(d) {
		     	return "translate(0," + y0(d.boxer) + ")";
		    });  

		//Appends main bar   
		var bars = categoryGroup.append("rect")
		    .attr("width", function(d) { return xScale(d.count); })
		    .attr("height", barHeight - 1 )
		    .attr("class", function(d) {
		    	return "g-" + d.type;
		    })
		    .attr("transform", "translate(0,4)"); 

		//Appends the x axis    
		var xAxisGroup = svg.append("g")
		    .attr("class", "x axis")
		    .call(xAxis);  

		//RESPONSIVENESS
		d3.select(window).on("resize."+category.toLowerCase().replace(' ', '-'), resized);

		function resized() {

			//new margin
		    var newMargin = {top: 15, right: 15, bottom: 0, left: 126};

		    //Get the width of the window
		    var w = d3.select(".gia-chart").node().clientWidth;

		    //Change the width of the svg
		    d3.selectAll("svg")
		      .attr("width", w)
		      .style("width", w);

		    //Change the xScale
		    xScale.range([0, w - newMargin.right - newMargin.left]);

		    //Update the bars
		    bars.attr("width", function(d) { return xScale(d.count); });  

			/*
		    Updates bar labels
		    barLabels
		      .attr("x", function(d) { 
		        if (minX > 85) {
		          return xScale(d.num) - 33;}
		        else {
		          return xScale(d.num) + 6;}})
		      .attr("y", y0.rangeBand()/1.5)
			*/

		    //Updates xAxis
		    xAxisGroup.call(xAxis);   

		    //Updates ticks
		    xAxis.scale(xScale);
		};
	}
}